@let popupTitle = "cerrixEditorPopup.popupTitle" | transloco;
@let closeButtonText = "cerrixEditorPopup.closeButton" | transloco;

<button class="btn btn-cerrix" (click)="openPopup(popupTitle, closeButtonText)">
    <i class="fas fa-pencil"></i>
    <span>{{ "cerrixEditorPopup.editButton" | transloco }}</span>
</button>

<ng-template #editorTemplate>
    <div class="cerrix-editor-in-popup">
        <cerrix-editor
            [value]="loadedValue"
            (valueChange)="valueChange.emit($event)"
        ></cerrix-editor>
    </div>
</ng-template>
